import type { TableOrder, TableStatus } from '../shared/types';

export function getTableStatus(order: TableOrder | undefined): TableStatus {
  if (!order || order.items.length === 0) return 'frei';
  if (order.items.some((item) => item.sent && !item.delivered)) return 'offen';
  return 'unbezahlt';
}
